import { Component, h, Prop } from "@stencil/core";
import { scrollToTop } from "../../utils/scroll-to-top";

@Component({
    tag: "ux-scroll-to-top-button",
    styleUrl: "scroll-to-top-button.scss",
    shadow: false,
})
export class ScrollToTopButton {
    /** gives the button a square look */
    @Prop() square: boolean = false;

    render() {
        return (
            <button
                class={{
                    "ux-scroll-to-top-button": true,
                    "ux-button": true,
                    "ux-scroll-to-top-button--square": this.square,
                }}
                onClick={() => scrollToTop()}
            >
                <ux-icon name="arrow-up" weight="normal" />
            </button>
        );
    }
}
